const NAME_KEY = "livekit_user_display_name";
const ROOM_KEY = "livekit_last_room_id";

export function getStoredDisplayName() {
  try {
    return (localStorage.getItem(NAME_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function setStoredDisplayName(name) {
  try {
    const v = (name || "").trim();
    if (v) localStorage.setItem(NAME_KEY, v);
  } catch {
    /* ignore */
  }
}

export function getStoredRoomId() {
  try {
    return (localStorage.getItem(ROOM_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function setStoredRoomId(roomId) {
  try {
    const v = (roomId || "").trim();
    if (v) localStorage.setItem(ROOM_KEY, v);
  } catch {
    /* ignore */
  }
}
